/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './components/Table';
import { Classes, Staff } from './ClassesSlice';
import EmptyAddScreen from '../../../components/EmptyAddScreen';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import CardHeader from '../../../components/CardHeader';
import { ConvertToTitleCase } from '../../../CommonMethods/ConvertToTitleCase';
import EditClass from '../../../components/ManageClasses/EditClass';
import { handleEndpoint, handleName, handleNavigation } from '../../../CommonMethods/Keyshandler';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';

const ManageClasses = ({type}) => {
    const { isSideNavBar, setToastErrorMessage, setToastmessage,isPageLoadingGlobal, setIsPageLoadingGlobal} = useContext(GlobalContext);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ClassList = useSelector(state => state.ClassesSlice);
    // const { List} = ClassList;
    const [List, setList] = useState({})
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('')
    const [fistLoading, setFirstLoading] = useState(false)
    const [editValue, setEditValue] = useState({});
    const [FilterData, setFilterData] = useState({});
    const [editOpen, setEditOpen] = useState(false);
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [editData, seteditData] = useState({})

    const initialInputValue = {
        admin_first_name : '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number:'',
        roles:[]
    }
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    const abortController = useRef(new AbortController());

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        // setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */  
    const getBranch = useCallback(async (arg) => {    
        // Cancel the previous request if a new one is triggered
        if (abortController.current) {
            abortController.current.abort();
        }
        
        // Create a new AbortController instance for the current request
        abortController.current = new AbortController();
        if(arg===undefined){
            setLoading(true)
        }
        try {
            setIsPageLoadingGlobal(true)
            setLoading(true)
            const branch_id = await GetBranchId()
            seteditData({})
            let response
            const Endkey = handleEndpoint(type);
        
            if(searchParams.get('sort') !== null || searchParams.get('page_number') !== null){
                response = await dataService.GetAPI(
                    `${Endkey}?branch_id=${branch_id.toString()}&${(searchParams.toString())}`
                );
            } else if (searchParams.toString() !== 'page_number=1&sort=created_at%2Bdesc'){
                if (type === 'classes' || type === 'sections') {
                    response = await dataService.GetAPI(
                        `${Endkey}?branch_id=${branch_id.toString()}&page_number=1`
                    );
                }
                else {
                    response = await dataService.GetAPI(
                        `${Endkey}?branch_id=${branch_id.toString()}&page_number=1&sort=created_at%2Bdesc`
                    );
                }
            } else {
                return;
            }
            // dispatch(Classes({searchParams,branch_id,Endkey})).then((response) => {
            if (response.data.status===200) {
                setList(response?.data.data)
                if(response.data.data.data?.length === 0 && searchParams.get('search')===null && searchParams.get('filter')===null && response?.data.data.total_count === 0) {
                    setFirstLoading(true);
                } else {
                    setEmptyScreenMessage("No matching records found.")  
                }
                if(Math.ceil(response?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                    if(response?.data?.data.total_count !== 0) {
                        // setToastErrorMessage('Something went wrong. Please try again')
                        setEmptyScreenMessage("No data found");
                    } else {
                        setEmptyScreenMessage("No matching records found.")
                    }
                    setLoading(false);
                    setIsPageLoadingGlobal(false)
                } else {
                    setLoading(false);
                    setIsPageLoadingGlobal(false)
                }
            } else {
                setLoading(false);
                setIsPageLoadingGlobal(false)
                setEmptyScreenMessage("No data found");
                // setToastErrorMessage('Something went wrong. Please try again')
            }
            // })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        } catch (error) {
            if (error.name === 'AbortError' || error?.response?.status === 'cancelled') {
                handleLoadData()
                return;
            } else {
                handleLoadData()
                setLoading(false)
                setIsPageLoadingGlobal(false)
                setEmptyScreenMessage("No data found");
                // setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }

        } 
    }, [searchParams, type]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [type]
    );

    // const optimizedFn = (key, value) =>{
    //     let timer = null;
    //     clearTimeout(timer);
    //     // Set a new timer
    //     timer = setTimeout(handleSearchParams(key,value), 500);
    // }
    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        // if(!searchParams.get('sort')) {
        //     handleSearchParams('sort', `created_at+desc`)
        // }
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getBranch();
        return () => { 
            setLoading(false);
            setFirstLoading(false)
        }
    }, [searchParams,type]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if(type === 'Edit') {
            setInputValue({
                admin_first_name : item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
            setEditValue(item)
        } else {
            setInputValue(initialInputValue)
        }
        setAddOpen(false);
    }

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`admin-users/update/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            setLoadingActivation(false);
            if (response.data.success_status) setToastmessage(response.data.message);
            else setToastErrorMessage(response.data.message);
            handleConformationClick();
            setLoading(true)
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }
   
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item]?.length !== 0) {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }
    /**
     * The function `handleApplyFilter` updates the search parameters based on the selected filter
     * options and triggers a count update.
     */
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("It seems there's nothing to display here.");
        let params = Object.fromEntries(searchParams);
        if(type) {
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                if(FilterCheckbox[item]?.length !== 0 ) {
                    let val = ""
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            delete params.filter
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item]   
            })
            setSearchParams({ ...params})
            setFilterCheckBox([])
        }
        getCount(type)
    }

    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow
                    AddButton={true}
                    SearchInput={(type==='sections') ? false : true}
                    Tittle={ConvertToTitleCase( type === 'fee head'? 'fee heads' : type === 'exam' ? 'exams' : type)}
                    AddButtonName={`Add ${handleName(type)}`}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    handleSidePopupClick={handleSidePopupClick}
                    isClick={handleNavigation(type)}
                    ApplyFilter={false}
                    FilterData={FilterData}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    loading={loading}
                    customSearchPlaceHolder={`${handleName(type)} Name`}
                    hideRightContentIfInactiveBranch={true}
                    rightContent={(type === 'classes' || type === 'sections') ? (
                        <button
                            type="button"
                            className="cancl-btn"
                            onClick={() => {
                                navigate(type === 'classes'
                                    ? '/main-hub/classes/reorder'
                                    : '/main-hub/manage-sections/reorder');
                            }}
                        >
                            Reorder
                        </button>
                    ) : null}
                />
                <CardHeader body>
                    {loading ? <ItemShimmer />
                        : (
                            <>
                                <Table
                                    handleSidePopupClick={handleSidePopupClick}
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickSort={handleSearchParams}
                                    sortValue={searchParams.get('sort') || ''}
                                    setConfirmationState={setConfirmationState}
                                    email={email}
                                    setLoading={setLoading}
                                    handleName={handleName}
                                    type={type}
                                    editOpen={editOpen}
                                    setEditOpen={setEditOpen}
                                    setEditData={seteditData}
                                    editData={editData}
                                    handleEndpoint={handleEndpoint}
                                    getBranch={getBranch}
                                    List={List}
                                    searchParams={searchParams}

                                />
                                {editOpen && <EditClass
                                    sideModelType={ConvertToTitleCase(handleName(type))}
                                    handleSidePopupClick={() => setEditOpen(false)}
                                    setInputValue={seteditData}
                                    type={type}
                                    handleEndpoint={handleEndpoint}
                                    inputValue={editData}
                                    setEditOpen={setEditOpen}
                                    handleName={handleName}
                                    getBranch={getBranch}
                                />}

                                {(List.total_count > 10) && <Pagination
                                    TotalCount={List.total_count}
                                    totalPageNumber={Math.ceil(List.total_count / 10)}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                />}
                            </> 
                        )}  </CardHeader>

            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this user ?`}
                        buttonName = {confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default ManageClasses;
